<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Finished_Goods_Transfers_Title' | translateWF: 'Finished Goods Transfers' }}</h1>
        @if (canEdit()) {
          <div class="page__title_buttons">
            <p-button [label]="'Finished_Goods_Transfers_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails()" />
          </div>
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      <!-- Filters Panel -->
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <!-- Data Table Panel -->
      <p-panel [header]="'Finished_Goods_Transfers_Title' | translateWF: 'Finished Goods Transfers'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="finishedGoodsTransfers()" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'Finished_Goods_Transfers_Number' | translateWF: 'Transfer Number' }}</th>
                <th>{{ 'Finished_Goods_Transfers_Production_Card' | translateWF: 'Production Card' }}</th>
                <th>{{ 'Finished_Goods_Transfers_From_Location' | translateWF: 'From Location' }}</th>
                <th>{{ 'Finished_Goods_Transfers_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Finished_Goods_Transfers_Roll_Numbers' | translateWF: 'Roll Numbers' }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transfer>
              @let transferStrict = getTransferStrict(transfer);
              <tr class="cursor-pointer" (click)="redirectToDetails(transfer.id)">
                <td>
                  <a>{{ transfer.number }}</a>
                </td>
                <td>{{ transferStrict.initiator.number }}</td>
                <td>{{ transferStrict.locationName || transferStrict.fromLocationCode }}</td>
                <td>{{ getStatusLabel(transfer.status) }}</td>
                <td>{{ getRollNumbers(transfer) }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">
                  {{ 'Finished_Goods_Transfers_Not_Found' | translateWF: 'No Finished Goods Transfers Found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Pagination -->
          <p-paginator
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [first]="(currentPage - 1) * pageSize"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            class="mt-4"
          ></p-paginator>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
